var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallInline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.5,
    height: 29.5,
    transform: "matrix(1 0 0 -1 0.139404 27.0366)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_87_181",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_87_181",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE7klEQVR4nO2dXaxdQxTH/0XjK4IiQsRHKqhESIRHbTTBoxQJD6pphOQi9ZGIF9acc3tviUjTtCIHqRIP6tVHSBNpaRCkVeWBpE24JU2r9EYQrvrL7O5b93Ju795nZu/Ze2b9kvV69qz13zN7Zs2aOYCiKIqiKIqiKIqiKIqiKIriDgVnUnATDR6gwRoa9Ch4hYINNHicBndQcJ6HRykzwQ6uocEqCj6jwSEacFYTfE7Bg3wKp8z4w0pxKDiNgvuzwBYRYGZhDtLgEfYwt8TjlUm4CqdT0KXBuJMQ/xfmC3ax4MiDlKNjhxYKTP5GsyL7hR3cMktTFHZwGwV7KhRiqtlv0L0a9T5wGPMpeLsmIaYOX39TsKxfm5KEwBwaPESD32sX419R/mQHi5E6HMHZNHgrmBDTRfmBgnlIFQqWUPBjcCGm2wtIDfYwl4J1DQh+/6FLcCGSGqIE7wcP/NFFGUUKUHAtDcaCB3x224nYoWBZ0FlUORtH1FNagWlAkMvY14j2423wUgMCXNaGEWUuyuDdBgS3rH1EwUmICa7EORRsa0Bwy013DVZTcAJigsO4iILdwQNczjZRcDlig4JLWjKtnbQxCpYiRtjFAhp834AgF7Ff872WuIanSSi4ioJ9DQh0EXsj6tQI7epb8JOnYE1Q8EketG+8CmH34jtYiARSIeOeAraZXVw67fc7WOxc1GBwgIIhvo5jETPs4srMWT9vcG+mKhAKjrEfXhrsL/mbh7L6rBGchdixbzIFez0I8QcFdxd6pmBeXghXpA5ri31hkAIUXJztrLmLsZ+CRaWf38XV2Wq6/7C3J+tNwBykQL7o+86DGDspOH/gdthhzOAuGnyQ9VSbFRA8yqdxMlIhT4e4r8AF79kqxND+xFC05p6bErzGNTg+tD8x7H+/40GMVyk4LrQ/MWwurffwzXjOjvuh/Wk9dqPGQ89YF9qPmPbAXcVYn8wUtIYDMa4FCRujT1fUWNrpuqexRWdT/mZUmx3F+MoesvHRnuShwVrHb8ZelxW4MgUKbvZQzr9Qg+oBCs4dIL3N/whyj4rh77CM6/mMtSqGJ7Kz264zqp4eMfZ3ps9tvTFBwWV+WqPY3vGmY+/4VMPoCQpudRSD9sSsCuKvENpHheEuzVX5EMRAPIjBvJfc4KNNycIncarHwjZS8KXOslwEOXyRCz3bCn+vTHq9w/9lLoKDNksc2r/WQYP7KugdzEXZENq/1lHpqSbJLnC5LrSPrSGv+KtGDHNElG26S1hUEMFo5YKYTJTl1b5akWDTHDUJ8mFoX9txlWrR2zvdBdkX2t/Gww5urEUMk9mO0P42nux61boEETwW2t/Gkx90qUOQsaSOBAxKbfeNCG4P7WsroMHLNYixVVPxRQURvFixGH/Zs+rVvlYRkf9LQJU95NnQPrYKO7ZXKMYBjuKM0D62rxDOJv+qGa6GQvvXSmiwvQJBdmgycXBBVlTQOxb5fW3SqzT52aMgG0P71HooeNhTz/iNw7ggtD+txx5L9nC7jhXkidC+xHYNn8uVSt9Gd2tnaOzf/GSr68F6x5LQ7Y8Se8BmgLXJptDtjhoa3JndWVVMjAl2cUXoNkcPBdcXvE10dei2pvanjc/ntzv3+258zGdwYuh2JoddW1CwMkuJ2JnY4ZtBR3RWpSiKoiiKoiiKoigKWsE/h5BDwlXBSKoAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallInline);
export default __webpack_public_path__ + "static/media/call_inline.86d137ef4b266eefa8c8708437877448.svg";
export { ForwardRef as ReactComponent };